/** code generate by generateapi don't edit */
import { global } from '@planjs/utils'; // eslint-disable-next-line @typescript-eslint/no-explicit-any

var defaultClientKey = '__pin_client__';
/**
 * 本地client
 */

var client;
/**
 * 设置私有client这里是挂在在全局变量上面的
 * @param c
 * @param key
 */

export function setClient(c) {
  var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultClientKey;

  if (typeof c === 'function') {
    global[defaultClientKey] = c;
  }
}
/**
 * 设置本地client，不和全局变量共享，优先级比全局变量高
 * @param c
 */

export function setLocalClient(c) {
  if (typeof c === 'function') {
    client = c;
  }
} // eslint-disable-next-line @typescript-eslint/no-explicit-any

export function getClient(r, o) {
  if (o && o.client && typeof o.client === 'function') {
    return o.client(r, o);
  }

  if (client && typeof client === 'function') {
    return client(r, o);
  }

  var key = (o === null || o === void 0 ? void 0 : o.__clientKey__) || defaultClientKey;

  if (global[key] && typeof global[key] === 'function') {
    return global[key](r, o);
  }

  console.warn('Request parameter', r, o);
  return Promise.reject(new Error('You must register a http client'));
}